/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class PanelTargetManageEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            example: {
                name: 'Target Name',
                code: 'CODE',
                units: 'umL',
                refRange: '0-1.0',
                critRefRange: '<0.1 or >10.0'
            }
        }
    }

    componentDidMount() {
        if (!this.props.modal && this.props.params?.id && this.props.params.id !== 'new') {
            this.fillItem('/api/target/get/' + this.props.params.id, 'item');
        }
    }


    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    submit = async (e) => {
        e?.preventDefault();
        if (this.state.saving || this.state.suggesting) return;
        this.setState({ saving: true });
        try {
            var j = await qreq.postAsync('/api/target/save', this.state.item);
            if (j.errorCode === 0) {
                this.success('Target saved');
                if (this.props.onSubmit)
                    this.props.onSubmit(j.item || { ...this.state.item });
                else
                    this.goBack();
            }
            else
                this.alert(j.errorMessage || 'Error saving target');
        }
        catch (e) {
            this.alert(e);
        }
        finally {
            this.setState({ saving: false });
        }
    }

    render() {
        return <div className={!this.props.modal ? 'container-fluid u-page' : ''}>
            <form id={this.props.formId} onSubmit={this.submit}><fieldset disabled={this.state.saving} className="border-0 p-0 m-0 w-100">
                {!this.props.modal && <header className="u-header">
                    <h1><L>{this.props.params?.id && this.props.params.id !== 'new' ? 'Edit Target' : 'New Target'}</L></h1>
                    <p className="u-intro"><L>Define result units, reference ranges, and reporting behavior.</L></p>
                </header>}
                <Card title="Basic Information">
                    <div className="row g-3">
                        <div className="col-md-8">
                            <FormInput model={this.state.item} name="name" label="Name" required placeholder={this.state.example.name} onChange={this.change} />
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="code" label="Code" required placeholder={this.state.example.code} onChange={this.change} />
                        </div>
                    </div>
                </Card>

                <Card title="Properties">
                    <div className="row g-3">
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="units" label="Units" onChange={this.change} placeholder={this.state.example.units} />
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="refRange" label="Reference Range" onChange={this.change} placeholder={this.state.example.refRange} />
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="critRefRange" label="Critical Reference Range" onChange={this.change} placeholder={this.state.example.critRefRange} />
                        </div>
                    </div>
                </Card>

                <Card title="Settings">
                    <div className="row g-3">
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isHidden" label="Hidden" type="switch" onChange={this.change} />
                            <small className="text-body-secondary"><L>Hide this target from the result report.</L></small>
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isOptional" label="Optional" type="switch" onChange={this.change} />
                            <small className="text-body-secondary"><L>Make this target optional for the report to be finalized.</L></small>
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isDisabled" label="Disable" type="switch" onChange={this.change} />
                            <small className="text-body-secondary"><L>Disable the target completely from use.</L></small>
                        </div>
                    </div>
                </Card>
                {!this.props.modal ? <AppActions>
                    <button type="submit" className="btn btn-success btn-lg" disabled={this.state.saving || this.state.suggesting}><Icon icon="faSave" /> <L>{this.state.saving ? 'Saving...' : 'Save'}</L></button>
                </AppActions> : <button type="submit" className="btn btn-success btn-lg d-none" id="btn-panel-target-submit"></button>}
            </fieldset></form>
        </div>;
    }
}

export default withParamsAndNavigate(PanelTargetManageEdit);